<template>
  <div>
    <form
      ref="form"
      data-url="/declarationsStartProccess"
      :class="{ 'loading-opacity': preloader }"
    >

      <div class="row">
        <div class="col-md-12">
          <legend>
            <p class="text-primary">
              DECLARACIÓN PARA INICIAR EL PROCESO DE EVALUACIÓN Y ACUSE RECIBO
            </p>
          </legend>
          <app-note
            note-type="note-red"
            :show-title="false"
            :notes="formNoteInstruction"
          />
          <br />
          <p>
            Yo, <b>{{ user }}</b> en calidad de gestor de expediente asignado,
            una vez revisada la documentación y verificado los recursos con
            fecha {{ date | dateFormat }}, determino que:
          </p>
          <table id="compliance-commitment" v-if="!showBox">
            <tr v-for="(item, key) in opt" :key="key">
              <td class="name">
                {{ item.name }} <strong class="text-danger">*</strong>
              </td>
              <td class="is-checked">
                <app-input
                  type="radio-buttons"
                  v-model="item.option"
                  :required="true"
                  :list="list"
                />
              </td>
            </tr>
          </table>

          <table id="compliance-commitment" v-if="showBox">
            <tr v-for="(item, key) in inputs.request" :key="key">
              <td class="name">
                {{ item.registration_request_observation.name
                }}<strong class="text-danger">*</strong>
              </td>
              <td class="is-checked">
                <app-input
                  type="radio-buttons"
                  v-model="item.option"
                  :required="true"
                  :list="list"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <br />
      <hr />
      <p>
        <b>Observaciones:</b> Colocar alguna consideración específica pertinente
        a la etapa de revisión de la solicitud y revisión de los recursos.
      </p>
      <!-- <p>
        Por lo anteriormente expuesto, con fecha {{ date | dateFormat }} se
        concluye que el OEC deberá solventar las observaciones pertinentes y
        remitirlas al SAE en el tiempo y forma establecido por una única vez,
        según lo descrito en el Procedimiento de Acreditación PA06.
      </p> -->

      <div class="form-group">
        <label>
          {{ $t("Seleccionar observaciones:") }}
          <strong class="text-danger">*</strong>
        </label>
        <app-input
          v-if="observation"
          type="multi-select"
          v-model="description_scope_array"
          :isAnimatedDropdown="true"
          :list="observation"
          :disabled="disabledsupport"
          @click="onChange()"
        />
      </div>

      <div class="form-group" v-if="text_complete">
        <label>
          {{ $t("Seleccionada:") }}
        </label>
        <div v-for="(item, key) in text_complete" :key="key">
          <p>{{ item }}</p>
          <hr />
        </div>
      </div>

      <div class="row" v-if="!inputs.reject_counter">
        <div class="col-md-12 mb-3">
          <legend>
            <p class="text-primary">
              	¿SE DEVOLVERÁ LA SOLICITUD AL OEC?
            </p>
          </legend>
          <app-input
            type="radio-buttons"
            v-model="correction_request"
            :list="typeCorrection"
          />

          <div class="py-3" v-if="correction_request">
            <app-note
            note-type="note-red"
            :show-title="false"
            :notes="['Seleccione las opciones a modificar.']"
          />
            <table class="table-striped mt-2">
              <tr>
                <td><b>Modificación de Solicitud</b></td>
                <td class="px-3">
                  <input
                    type="checkbox"
                    v-model="inputs.change_request"
                    
                  />
                </td>
              </tr>
              <tr>
                <td><b>Modificación de Alcances</b></td>
                <td class="px-3">
                  <input
                    type="checkbox"
                    v-model="inputs.change_scopes"
                    
                  />
                </td>
              </tr>
              <tr>
                <td><b>Modificación de Anexos</b></td>
                <td class="px-3">
                  <input
                    type="checkbox"
                    v-model="inputs.change_annexes"

                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <button class="btn btn-primary" :disabled="disabledsupport" @click.prevent="submit">
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
import moment from "moment";
export default {
  name: "ComplianceCommitment",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      attached_file: {},
      list: [
        {
          id: "NO",
          value: "NO",
        },
        {
          id: "SI",
          value: "SI",
        },
        {
          id: "NA",
          value: "N/A",
        },
      ],
      correction_request: 1,
      typeCorrection: [
        {
          id: 0,
          value: "No",
        },
        {
          id: 1,
          value: "Si",
        },
      ],
      description_scope_array: [],
      formNoteInstruction: [
        this.$t("Todos los campos con un (*) son obligatorios."),
      ],
      deleteModal: false,
      delete_file: false,
      observation: "",
      opt: "",
      user: "",
      description_scope: "",
      text_complete: "",

      array_text: [],
      showBox: false,
      date: new Date(),
      formRowInstruction1: [this.$t("DECLARATION_START_PROCCESS_statement")],
      pdf: "/common/pdf/complianceCommitment?accreditation_application_id=",
      disabledsupport: false,
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD");
    },
  },

  watch: {
    description_scope_array: function () {
      this.onChange();
    },
  },

  computed: {
    status() {
      return this.$store.state.accreditation.app != null &&
        this.$store.state.accreditation.app.status != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },

    disabled() {
      return this.status != null && this.status != "112";
    },
  },

  created() {
    this.data();
    this.options();
    this.disabledsupport = localStorage.getItem("auth_id") === "true";
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      if (this.correction_request && !this.inputs.change_scopes && !this.inputs.change_annexes && !this.inputs.change_request) {
        this.$toastr.e(this.$t("Seleccione por lo menos una opción para devolver la solicitud"));
        return;
      }
      if (this.description_scope_array.length > 0) {
        var info = {};
        info["accreditaion_id"] = this.$store.state.accreditation.id;
        if (this.inputs.request.length > 0) {
          info["selected"] = this.inputs.request;
        } else {
          info["selected"] = this.opt;
        }
        info["description_scope"] = this.description_scope_array;
        if(!this.correction_request) {
          info["change_scopes"] = 0;
          info["change_annexes"] = 0;
          info["change_request"] = 0;
        } else {
          info["change_scopes"] = this.inputs.change_scopes ? 1 : 0;
          info["change_annexes"] = this.inputs.change_annexes ? 1 : 0;
          info["change_request"] = this.inputs.change_request ? 1 : 0;
        }
        this.save(info);
      }else{
        this.$toastr.e("Es necesario seleccionar una observación");
      }
    },

    afterSuccess(res) {
      this.$toastr.s("Registrado con éxito");
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    onChange() {
      var url = `${actions.DECLARATION_START_PROCCESS}/selectedData`;
      var request = {};
      request["listId"] = this.description_scope_array;
      axios
        .post(url, request)
        .then((response) => {
          this.text_complete = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.preloader = false;
        });
    },

    openTab() {
      let w;
      w = window.open(
        `/common/pdf/generate?accAppId=${this.$store.state.accreditation.id}`,
        "_blank"
      );
      w.focus();
    },

    data() {
      this.preloader = true;

      this.axiosGet(
        `${actions.DECLARATION_START_PROCCESS}/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          this.inputs.request = response.data.request;
          this.inputs.description_scope = response.data.acc.request_id;
          this.inputs.change_scopes = response.data.acc.change_scopes;
          this.inputs.change_annexes = response.data.acc.change_annexes;
          this.inputs.change_request = response.data.acc.change_request;
          this.inputs.reject_counter = response.data.acc.reject_counter;
          
          if (this.inputs.change_scopes || this.inputs.change_annexes || this.inputs.change_request) {
            this.correction_request = 1;
          }
          if (this.inputs.request.length > 0) {
            this.showBox = true;
          } else {
            this.showBox = false;
          }

          if (response.data.acc.request_id);
          {
            var clean = response.data.acc.request_id.replace("[", "");
            var clean2 = clean.replace("]", "");
            var arrayString = clean2.split(",");
            var arrayInt = [];
            for (let item of arrayString) {
              arrayInt.push(parseInt(item));
            }
            this.description_scope_array = arrayInt;

            var url = `${actions.DECLARATION_START_PROCCESS}/selectedData`;
            var request = {};
            request["listId"] = this.description_scope_array;
            axios
              .post(url, request)
              .then((response) => {
                this.text_complete = response.data;
              })
              .catch((error) => {})
              .finally(() => {
                this.preloader = false;
              });
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.preloader = false;
        });
    },

    options() {
      this.preloader = true;

      this.axiosGet(`${actions.DECLARATION_START_PROCCESS}/options`)
        .then((response) => {
          this.observation = response.data.observation;
          this.opt = response.data.options;
          this.user = response.data.user;
        })
        .catch((error) => {})
        .finally(() => {
          this.preloader = false;
        });
    },

    confirmed() {
      this.deleteModal = false;
      this.inputs.file = null;
      this.attached_file = null;
      this.delete_file = true;
    },

    cancelled() {
      this.deleteModal = false;
    },
  },
};
</script>
<style lang="css">
#compliance-commitment {
  width: 100%;
}
#compliance-commitment tr {
  border: 1px dotted gray;
}
#compliance-commitment td {
  padding: 0.8rem;
}
#compliance-commitment .name {
  text-align: justify;
}
#compliance-commitment .is-checked {
  width: 20%;
  text-align: right;
}
</style>